module.exports = __webpack_public_path__ + "assets/password.edb96aed.svg";